<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M8.8335 4.16667L11.0002 2L14.0002 5L11.8335 7.16667M8.8335 4.16667L1.8335 11.1667V14.1667H4.8335L11.8335 7.16667M8.8335 4.16667L11.8335 7.16667"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>
